import store from '@/store';
import authentication from '@/authentication';
import training from '@/components/training';
import Training from '@/screens/training/Training';
import TrainingVideos from '@/screens/training/TrainingVideos';
import log from '@/configured/logger';
const parent = { template: '<router-view></router-view>' };

const routes = [
  {
    path: '/training',
    component: parent,
    beforeEnter: async (to, from, next) => {
      await store.commit(`${authentication.store.namespace}/SET_WORKING`, true);
      try {
        await store.dispatch(`${training.store.namespace}/loadAll`);
        next();
      } catch (error) {
        log.error(
          'Error loading products and categories. Redirecting to error page.',
          error
        );
        next({
          name: 'Error',
          params: {
            errorCode: constants.ERROR.LOADING_PRODUCTS,
          },
        });
      } finally {
        store.commit(`${authentication.store.namespace}/SET_WORKING`, false);
      }
    },
    children: [
      {
        path: '',
        name: 'Training',
        component: Training,
      },
      {
        path: 'videos',
        name: 'TrainingVideos',
        component: TrainingVideos,
      },
    ],
  },
];

export default routes;
